module.exports = __webpack_public_path__ + "static/work43-e1d815fa1dfc2ae9041357fb74c3993b.jpg";